import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonOffIcon from '@mui/icons-material/PersonOff';
import moment from "jalali-moment";

// JS Files
import Navbar from "../../../shares/Navbar";
import Footer from "../../../shares/Footer";
import MuiButton from "../../../shares/MuiButton";
import StepThreeModal from "./StepThreeModal";
import { useUserData } from "../../../../context/UserDataContext";
import useFetch from "../../../../context/useFetch";
import { TreatmentProvince } from "../../../../TreatmentProvince";
import SuccessModal from "../../../record/SuccessModal";

// Others File

const StepThree = () => {
  const navigate = useNavigate();

  const [addModal, setAddModal] = useState(false);
  const [selectedSub, setSelectedSub] = useState();
  const handleAddModal = () => {
    setAddModal((before) => !before);
  };
  const [data, setData] = useState([]);
  const [unqiueID ,setUniqueID] = useState()
  const { userData } = useUserData();
  const GetUserTreatmentRequestServiceApi = useFetch({
    url: `User_Service/${userData.username}/user_get_treatment_request_info`,
    method: "GET",
    trigger: true,
    argFunc: (res) => {
      setData(res.data.treatment_request_main_insured[0].sub_insured);
      setUniqueID(res.data.unique_id)
    },
    errMessage: (res) => {},
  });

  const DeleteUserTreatmentRequestServiceApi = useFetch({
    url: `TreatmentRequestSubInsured_Service/${selectedSub}`,
    method: "DELETE",
    trigger: false,
    argFunc: (res) => {
      GetUserTreatmentRequestServiceApi.reFetch();
    },
    errMessage: (res) => {},
  });

  const [successModal , setSuccessModal] = useState(false);
  const handleSuccessModal = () => {
    setSuccessModal(before => !before);
  }
  return (
    <>
      {addModal && (
        <StepThreeModal
          openModal={addModal}
          setOpenModal={setAddModal}
          apiCall={GetUserTreatmentRequestServiceApi}
        />
      )}
      {successModal && (
        <SuccessModal
          openModal={successModal}
          setOpenModal={setSuccessModal}
          code={unqiueID}
        />
      )}
      <div className="hp-section-one">
        <Navbar activePage="aboutus" />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">ثبت‌نام بیمه تکمیلی</p>
        <div className="border rounded-lg mt-8 border-mygray-300 py-4 md:py-8 px-4">
          <div className="border-r-4 border-mygray-300 px-4">
            <span className="text-sm md:text-base font-bold text-mygray-700">
              افراد تحت تکفل
            </span>
          </div>
          <div className="my-4 flex justify-between items-center mx-4 md:mx-12">
            <span className="text-mygray-700 text-sm md:text-base">
              برای افزودن افراد تحت تکفل، از طریق دکمه افزودن اقدام نمایید.
            </span>
            <MuiButton
              onClick={() => handleAddModal()}
              variant="outlined"
              color="primary"
              text="افزودن"
            />
          </div>
          <div className="mx-4 md:mx-12">
            <span className="font-bold text-mygray-700">
              لیست افراد اضافه شده:
            </span>
            {data.length<=0 ? <>
            {/*........ empty list ........... */}
            <div className="border border-dashed rounded-lg mt-4 p-4">
              <div className="flex flex-col items-center justify-center">
                <PersonOffIcon
                  className="text-mygray-700"
                  sx={{ fontSize: "5rem" }}
                />
                <span className="text-mygray-700 text-sm md:text-base text-justify">
                  لیست افراد تحت تکفل خالی است، اگر فرد تحت تکفلی را نمی‌خواهید
                  اضافه نمایید، روی دکمه ثبت اطلاعات کلیک کنید.
                </span>
              </div>
            </div>
            </> : <>
            {/*........ have item ......... */}
            <div className="border border-dashed rounded-lg mt-4 p-4">
              <div className="grid grid-cols-2 md:grid-cols-10 items-center text-center bg-mygray-200 p-2 rounded-lg text-mygray-700 text-sm my-2 font-bold">
                <span>نام و نام خانوادگی</span>
                <span className="hidden md:inline">جنسیت</span>
                <span className="hidden md:inline">کدملی</span>
                <span className="hidden md:inline">نام پدر</span>
                <span className="hidden md:inline">تاریخ تولد</span>
                <span className="hidden md:inline">محل تولد</span>
                <span className="hidden md:inline">شماره شناسنامه</span>
                <span className="hidden md:inline">محل صدور</span>
                <span className="hidden md:inline">نسبت</span>
                <span>اقدام</span>
              </div>

              {data.map((it, ind) => {
                return [
                  <div className="grid grid-cols-2 md:grid-cols-10 items-center text-center bg-mygray-200 p-2 rounded-lg text-mygray-700 text-sm my-2">
                    <span>{it.name}</span>
                    <span className="hidden md:inline">{it.fa_gender}</span>
                    <span className="hidden md:inline">{it.code}</span>
                    <span className="hidden md:inline">{it.father_name}</span>
                    <span className="hidden md:inline">
                      {" "}
                      {moment(it.birth_date, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </span>
                    <span className="hidden md:inline">
                      {
                        TreatmentProvince.filter(
                          (its) => its.value == it.birth_provience
                        )[0].name
                      }{" - "}
                      {/* {it.birth_provience} */}
                      {it.birth_city}
                    </span>
                    <span className="hidden md:inline">{it.code}</span>
                    <span className="hidden md:inline">
                      {
                        TreatmentProvince.filter(
                          (its) => its.value == it.identify_provience
                        )[0].name
                      }{" - "}
                      {it.identify_city}{" "}
                    </span>
                    <span className="hidden md:inline">{it.fa_relation}</span>
                    <div className="flex items-start justify-center">
                      {/* <EditIcon className="ml-2 text-myblue-400" /> */}
                      <DeleteIcon
                        className="mr-2 text-myred-400"
                        onClick={() => {
                          setSelectedSub(it.id);
                          DeleteUserTreatmentRequestServiceApi.reFetch();
                        }}
                      />
                    </div>
                  </div>,
                ];
              })}
            </div>
            </>}
            
            
          </div>
        </div>
        <div className="text-left mt-8 flex justify-between items-center">
          <MuiButton
            onClick={() => navigate(-1)}
            type="submit"
            variant="outlined"
            color="primary"
            text="بازگشت"
          />
          <MuiButton
            // onClick={() => navigate("/step-two")}
            onClick={() => handleSuccessModal()}
            type="submit"
            variant="contained"
            color="primary"
            text="ثبت اطلاعات"
            // disabled={AddCaseApi.loading}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};
export default StepThree;
